// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__+wPdQ","spinner-border":"LoadingSpinner_spinner-border__VGjYl"};